export const getToken = () => {
    return sessionStorage.getItem("BEARER_TOKEN");
};

export const setToken = (token: string) => {
    sessionStorage.setItem("BEARER_TOKEN", token);
};

export const deleteToken = () => {
    sessionStorage.removeItem("BEARER_TOKEN");
};
